module.exports = __webpack_public_path__ + "static/img/platinum.dac0ef74.png";